import styled from "@emotion/styled"

export const StyledMain = styled.div`
  label {
    top: 0px;
    font-size: 18px;
    color: #000000 !important;
  }
  .MuiInputLabel-shrink {
    transform: translate(14px, 0px) scale(0.75);
    color: #000000;
  }
  .MuiSelect-select {
    font-size: 18px;
  }
  legend {
    display: none;
  }
  fieldset {
    border-color: black;
  }
  .MuiTabs-flexContainer {
    justify-content: space-between;

    ${(props) => props.theme.breakpoints.down("md")} {
      width: 100%;
      min-width: 100% !important;
    }
  }
`

export const StyledBreadCrumbsWrapper = styled.div`
  padding-top: 16px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 24px;
  }
`

export const StyledButtonDiv = styled.div`
  padding-top: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 60px;
  }
`

export const StyledWrapper = styled.div`
  padding-top: 32px;
  .MuiLinearProgress-colorPrimary {
    background-color: #b5bfc9;
  }
  .MuiLinearProgress-barColorPrimary {
    background-color: #2768a3;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 60px;
  }
  .MuiAccordionDetails-root {
    ${(props) => props.theme.breakpoints.down("md")} {
      padding-left: 0px;
      padding-right: 0px;
    }
  }
`

export const StyledTabsContainer = styled.div`
  position: relative;
  padding-top: 16px;
  ${(props) => props.theme.breakpoints.down("md")} {
    svg {
      width: 30px;
      height: 30px;
    }
    button {
      padding: 0px;
      min-width: 30px !important;
    }
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    button {
      min-width: 100px;
    }
  }
`

export const StyledSelectedValuesContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const StyledSelectedValue = styled.div`
  flex: 1;
  text-align: center;
  font-size: 12px;
  color: #6f6f6f;
  min-height: 16px;
  max-width: 100px;
  ${(props) => props.theme.breakpoints.up("md")} {
    font-size: 14px;
  }
`

export const StyledBackStep = styled.div`
  padding-top: 15px;
  button {
    :hover {
      outline: none;
      background-color: transparent;
    }
    ${(props) => props.theme.breakpoints.down("md")} {
      padding-top: 0px;
      padding-bottom: 0px;
    }
  }
  svg {
    margin-right: 8px;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 40px;
  }
`

export const StyledContent = styled.div`
  box-shadow: 0px 4px 12px 0px #00000029;
  background-color: white;
  width: 100%;
  min-height: 200px;
  padding: 24px 16px 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 24px;
  border-radius: 16px;
  ${(props) => props.theme.breakpoints.up("md")} {
    width: 360px;
  }
  .MuiLinearProgress-root {
    width: 100%;
  }
  .MuiLinearProgress-colorPrimary {
    background-color: #b5bfc9;
  }
  .MuiLinearProgress-barColorPrimary {
    background-color: #2768a3;
  }
`

export const StyledError = styled.div`
  padding-bottom: 8px;
  p {
    text-align: center;
  }
`
